/**
 * Toggles product view between grid and list.
 */
class ViewToggle {
  constructor() {
    /**
     * @type {{gridBtn: string, listBtn: string, grid: string, gridContainer: string}}
     */
    this.selectors = {
      gridBtn: '#grid-view-btn',
      listBtn: '#list-view-btn',
      grid: '.product-grid',
      gridContainer: '#ProductGridContainer' 
    };
    
    /** @type {HTMLElement | null} */
    this.productGrid = null;
    
    /** @type {NodeListOf<Element> | null} */
    this.gridBtns = null;
    
    /** @type {NodeListOf<Element> | null} */
    this.listBtns = null;
    
    /** @type {MutationObserver | null} */
    this.observer = null;

    this.init = this.init.bind(this);
    this.setView = this.setView.bind(this);
    this.handleMutations = this.handleMutations.bind(this);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.init);
    } else {
      this.init();
    }
  }
  
  init() {
    this.updateElements();
    
    const savedView = localStorage.getItem('productView') || 'grid';
    this.setView(savedView, false); 
    document.addEventListener('click', (/** @type {Event} */ e) => {
      const target = /** @type {HTMLElement} */ (e.target);
      if (target.closest && target.closest(this.selectors.gridBtn)) {
        this.setView('grid');
      } else if (target.closest && target.closest(this.selectors.listBtn)) {
        this.setView('list');
      }
    });

    const observerContainer = document.querySelector(this.selectors.gridContainer) || document.body;
    
    this.observer = new MutationObserver(this.handleMutations);
    this.observer.observe(observerContainer, {
      childList: true, 
      subtree: true    
    });
  }
  
  updateElements() {
    this.productGrid = /** @type {HTMLElement | null} */ (document.querySelector(this.selectors.grid));
    this.gridBtns = document.querySelectorAll(this.selectors.gridBtn);
    this.listBtns = document.querySelectorAll(this.selectors.listBtn);
  }

  /**
   * @param {MutationRecord[]} mutations
   */
  handleMutations(mutations) {
    let shouldUpdate = false;
    
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        const target = /** @type {HTMLElement} */ (mutation.target);
        if (target.classList?.contains('product-grid') || 
            target.id === 'ProductGridContainer' ||
            (target.closest && target.closest('.product-grid'))) {
          shouldUpdate = true;
          break;
        }
      }
    }

    if (shouldUpdate) {
      const savedView = localStorage.getItem('productView') || 'grid';
      setTimeout(() => {
        this.updateElements(); 
        this.setView(savedView, false);
      }, 50);
    }
  }
  
  /**
   * @param {string} viewType
   * @param {boolean} [save=true]
   */
  setView(viewType, save = true) {
    this.updateElements();
    
    if (!this.productGrid) return;

    if (viewType === 'list') {
      this.productGrid.classList.add('product-grid--list');
      document.documentElement.classList.add('view-list-active'); // Helper untuk CSS anti-glitch
    } else {
      this.productGrid.classList.remove('product-grid--list');
      document.documentElement.classList.remove('view-list-active');
    }
    
    if (this.gridBtns) {
      this.gridBtns.forEach(btn => btn.classList.toggle('active', viewType === 'grid'));
    }
    
    if (this.listBtns) {
      this.listBtns.forEach(btn => btn.classList.toggle('active', viewType === 'list'));
    }
    
    if (save) {
      localStorage.setItem('productView', viewType);
    }
  }
}

new ViewToggle();